(function() {
  'use strict';

  const CONFIG = {
    collectionHandle: 'christmas-collection',
    discountPercentage: 25
  };

  const state = {
    isChristmasProduct: false,
    productData: null,
    currentCurrency: null
  };

  function detectCurrentCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }

    if (window.Currency && window.Currency.currentCurrency) {
      return window.Currency.currentCurrency;
    }

    const currencyMeta = document.querySelector('meta[name="currency"]');
    if (currencyMeta) {
      return currencyMeta.content;
    }

    const priceText = document.querySelector('.price')?.textContent;
    if (priceText) {
      if (priceText.includes('$')) return 'USD';
      if (priceText.includes('£')) return 'GBP';
      if (priceText.includes('€')) return 'EUR';
      if (priceText.includes('₹')) return 'INR';
      if (priceText.includes('¥')) return 'JPY';
      if (priceText.includes('CA$')) return 'CAD';
      if (priceText.includes('A$')) return 'AUD';
      if (priceText.includes('د.إ')) return 'AED';
      if (priceText.includes('ر.س')) return 'SAR';
    }

    return 'GBP';
  }

  function getCurrencySymbol(currencyCode) {
    const symbols = {
      'USD': '$', 'GBP': '£', 'EUR': '€', 'CAD': 'CA$', 'AUD': 'A$',
      'NZD': 'NZ$', 'JPY': '¥', 'CNY': '¥', 'INR': '₹', 'AED': 'د.إ',
      'SAR': 'ر.س', 'QAR': 'ر.ق', 'OMR': 'ر.ع', 'KWD': 'د.ك',
      'BHD': 'د.ب', 'BDT': '৳', 'PKR': '₨', 'SGD': 'S$', 'HKD': 'HK$',
      'MYR': 'RM', 'THB': '฿', 'PHP': '₱', 'IDR': 'Rp', 'KRW': '₩',
      'VND': '₫', 'CHF': 'CHF', 'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr',
      'PLN': 'zł', 'CZK': 'Kč', 'HUF': 'Ft', 'RON': 'lei', 'BGN': 'лв',
      'RUB': '₽', 'TRY': '₺', 'ILS': '₪', 'ZAR': 'R', 'NGN': '₦',
      'EGP': 'E£', 'BRL': 'R$', 'MXN': 'MX$', 'ARS': 'AR$', 'CLP': 'CL$',
      'COP': 'CO$', 'PEN': 'S/.'
    };
    
    return symbols[currencyCode] || currencyCode + ' ';
  }

  function getCurrencyFormat(currencyCode) {
    const symbolAfterCurrencies = ['EUR', 'SEK', 'NOK', 'DKK', 'CZK', 'RON', 'PLN', 'BGN'];
    const noDecimalCurrencies = ['JPY', 'KRW', 'VND', 'CLP'];
    
    return {
      symbolAfter: symbolAfterCurrencies.includes(currencyCode),
      decimals: noDecimalCurrencies.includes(currencyCode) ? 0 : 2
    };
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') {
      cents = parseInt(cents) || 0;
    }

    state.currentCurrency = detectCurrentCurrency();

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        const formatted = window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
        if (formatted) return formatted;
      } catch (e) {}
    }

    if (window.Currency && typeof window.Currency.formatMoney === 'function') {
      try {
        return window.Currency.formatMoney(cents);
      } catch (e) {}
    }

    const currency = state.currentCurrency;
    const symbol = getCurrencySymbol(currency);
    const format = getCurrencyFormat(currency);
    
    const divisor = format.decimals === 0 ? 1 : 100;
    const amount = (cents / divisor).toFixed(format.decimals);
    
    if (format.symbolAfter) {
      return `${amount} ${symbol}`;
    } else {
      return `${symbol}${amount}`;
    }
  }

  function calculateDiscountedPrice(originalPrice) {
    const discount = originalPrice * (CONFIG.discountPercentage / 100);
    return Math.floor(originalPrice - discount);
  }

  function extractProductHandle(url) {
    if (!url) return null;
    
    try {
      const match = url.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    } catch (e) {
      return null;
    }
  }

  function applyDiscountToCard(cardElement, product) {
    if (!cardElement || !product) return;

    const priceElement = cardElement.querySelector('.card-information .price');
    if (!priceElement) return;

    if (cardElement.classList.contains('has-christmas-discount')) return;

    const originalPrice = product.price;
    const discountedPrice = calculateDiscountedPrice(originalPrice);

    const discountHTML = `
      <div class="christmas-discount">
        <div class="price-wrapper">
          <span class="sale-price">from ${formatMoney(discountedPrice)}</span>
          <span class="original-price">from ${formatMoney(originalPrice)}</span>
        </div>
        <span class="badge christmas-badge">25% OFF</span>
      </div>
    `;

    priceElement.innerHTML = discountHTML;
    cardElement.classList.add('has-christmas-discount');
  }

  function applyDiscountToProductPage(variantId = null) {
    if (!state.isChristmasProduct || !state.productData) return;

    const priceElement = document.querySelector('.product__info-container .price');
    if (!priceElement) return;

    let currentVariant;
    if (variantId) {
      currentVariant = state.productData.variants.find(v => v.id === variantId);
    } else {
      const variantInput = document.querySelector('[name="id"]');
      const selectedVariantId = variantInput ? parseInt(variantInput.value) : null;
      currentVariant = selectedVariantId 
        ? state.productData.variants.find(v => v.id === selectedVariantId)
        : state.productData.variants[0];
    }

    if (!currentVariant) return;

    const originalPrice = currentVariant.price;
    const discountedPrice = calculateDiscountedPrice(originalPrice);

    const discountHTML = `
      <div class="product-christmas-discount">
        <div class="product-price-wrapper">
          <span class="product-sale-price">${formatMoney(discountedPrice)}</span>
          <span class="product-original-price">${formatMoney(originalPrice)}</span>
        <span class="badge christmas-badge-large">🎄 25% OFF</span>

        </div>
      </div>
    `;

    priceElement.innerHTML = discountHTML;
    priceElement.classList.add('has-christmas-discount');
  }

  function setupVariantChangeListeners() {
    if (!state.isChristmasProduct) return;

    const variantInput = document.querySelector('[name="id"]');
    if (!variantInput) return;

    const observer = new MutationObserver(() => {
      const variantId = parseInt(variantInput.value);
      if (variantId) {
        applyDiscountToProductPage(variantId);
      }
    });

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    variantInput.addEventListener('change', () => {
      const variantId = parseInt(variantInput.value);
      if (variantId) {
        applyDiscountToProductPage(variantId);
      }
    });

    const variantControls = document.querySelectorAll(
      '.product-form__input input, .product-form__input select'
    );

    variantControls.forEach(control => {
      control.addEventListener('change', () => {
        setTimeout(() => {
          const variantId = parseInt(variantInput.value);
          if (variantId) {
            applyDiscountToProductPage(variantId);
          }
        }, 50);
      });
    });

    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('change', () => {
        clearTimeout(productForm._christmasTimeout);
        productForm._christmasTimeout = setTimeout(() => {
          const variantId = parseInt(variantInput.value);
          if (variantId) {
            applyDiscountToProductPage(variantId);
          }
        }, 100);
      });
    }
  }

  async function checkAndApplyDiscount(cardElement) {
    if (cardElement.classList.contains('has-christmas-discount') ||
        cardElement.classList.contains('christmas-checked')) {
      return;
    }

    cardElement.classList.add('christmas-checked');

    const isChristmas = cardElement.dataset.isChristmas === 'true';
    
    if (!isChristmas) {
      return;
    }

    const productLink = cardElement.querySelector('a[href*="/products/"]');
    if (!productLink) return;

    const productHandle = extractProductHandle(productLink.href);
    if (!productHandle) return;

    try {
      const response = await fetch(
        `/collections/${CONFIG.collectionHandle}/products/${productHandle}.js`
      );

      if (!response.ok) return;

      const product = await response.json();

      applyDiscountToCard(cardElement, product);

    } catch (error) {
      // Silent fail
    }
  }

  async function processAllProductCards() {
    const cards = document.querySelectorAll('.card-wrapper.product-card-wrapper .card');

    if (cards.length === 0) return;

    const batchSize = 5;
    const cardArray = Array.from(cards);

    for (let i = 0; i < cardArray.length; i += batchSize) {
      const batch = cardArray.slice(i, i + batchSize);
      await Promise.all(batch.map(card => checkAndApplyDiscount(card)));
      
      if (i + batchSize < cardArray.length) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
  }

  async function processProductPage() {
    const pathname = window.location.pathname;

    if (!pathname.includes('/products/')) return;

    // Try multiple selectors to find the data-is-christmas attribute
    let isChristmas = false;
    
    // Method 1: Check product-info element (your Liquid code)
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      // Check both spellings (in case of typo)
      isChristmas = productInfo.dataset.isChirstmas === 'true' || 
                   productInfo.dataset.isChristmas === 'true';
    }
    
    // Method 2: Check any element with data-is-christmas
    if (!isChristmas) {
      const christmasElement = document.querySelector('[data-is-christmas]');
      if (christmasElement) {
        isChristmas = christmasElement.dataset.isChristmas === 'true';
      }
    }
    
    // Method 3: Check any element with data-is-chirstmas (typo version)
    if (!isChristmas) {
      const christmasElement = document.querySelector('[data-is-chirstmas]');
      if (christmasElement) {
        isChristmas = christmasElement.dataset.isChirstmas === 'true';
      }
    }

    if (!isChristmas) {
      state.isChristmasProduct = false;
      return;
    }

    const productHandle = extractProductHandle(pathname);
    if (!productHandle) return;

    try {
      const response = await fetch(
        `/collections/${CONFIG.collectionHandle}/products/${productHandle}.js`
      );

      if (!response.ok) return;

      const productData = await response.json();

      state.isChristmasProduct = true;
      state.productData = productData;

      // Wait for DOM to be ready
      setTimeout(() => {
        applyDiscountToProductPage();
        setupVariantChangeListeners();
      }, 100);

    } catch (error) {
      console.error('[Christmas Discount] Error on product page:', error);
    }
  }

  async function init() {
    state.currentCurrency = detectCurrentCurrency();

    try {
      await Promise.all([
        processProductPage(),
        processAllProductCards()
      ]);
    } catch (error) {
      console.error('[Christmas Discount] Initialization error:', error);
    }
  }

  function setupCurrencyChangeListeners() {
    const currencyEvents = ['currency:changed', 'currencyChanged', 'Currency:changed'];
    currencyEvents.forEach(eventName => {
      document.addEventListener(eventName, () => {
        handleCurrencyChange();
      });
    });

    const currencySelectors = document.querySelectorAll(
      '[data-currency-picker], .currency-picker, select[name="currency"]'
    );
    
    currencySelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        setTimeout(handleCurrencyChange, 500);
      });
    });

    if (window.Currency && window.Currency.convertAll) {
      const originalConvertAll = window.Currency.convertAll;
      window.Currency.convertAll = function() {
        const result = originalConvertAll.apply(this, arguments);
        setTimeout(handleCurrencyChange, 300);
        return result;
      };
    }
  }

  function handleCurrencyChange() {
    document.querySelectorAll('.has-christmas-discount, .christmas-checked').forEach(el => {
      el.classList.remove('has-christmas-discount', 'christmas-checked');
    });
    
    state.currentCurrency = detectCurrentCurrency();
    state.isChristmasProduct = false;
    state.productData = null;
    
    setTimeout(init, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      setupCurrencyChangeListeners();
    });
  } else {
    init();
    setupCurrencyChangeListeners();
  }

  document.addEventListener('shopify:section:load', () => {
    setTimeout(init, 100);
  });

  // Handle Shopify 2.0 theme variant changes
  document.addEventListener('variant:change', () => {
    if (state.isChristmasProduct && state.productData) {
      setTimeout(() => {
        const variantInput = document.querySelector('[name="id"]');
        const variantId = variantInput ? parseInt(variantInput.value) : null;
        if (variantId) {
          applyDiscountToProductPage(variantId);
        }
      }, 50);
    }
  });

  const observer = new MutationObserver((mutations) => {
    let hasNewCards = false;

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 &&
            (node.classList?.contains('card-wrapper') ||
             node.classList?.contains('card') ||
             node.querySelector?.('.card-wrapper, .card'))) {
          hasNewCards = true;
          break;
        }
      }
      if (hasNewCards) break;
    }

    if (hasNewCards) {
      setTimeout(processAllProductCards, 300);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();